export let DateFormat = /*#__PURE__*/function (DateFormat) {
  DateFormat[DateFormat["FullDateTime"] = 0] = "FullDateTime";
  DateFormat[DateFormat["LongDate"] = 1] = "LongDate";
  DateFormat[DateFormat["LongTime"] = 2] = "LongTime";
  DateFormat[DateFormat["MonthDay"] = 3] = "MonthDay";
  DateFormat[DateFormat["ShortDate"] = 4] = "ShortDate";
  DateFormat[DateFormat["ShortDateLongTime"] = 5] = "ShortDateLongTime";
  DateFormat[DateFormat["ShortDateTime"] = 6] = "ShortDateTime";
  DateFormat[DateFormat["ShortTime"] = 7] = "ShortTime";
  DateFormat[DateFormat["SortableDateTime"] = 8] = "SortableDateTime";
  DateFormat[DateFormat["UniversalSortableDateTime"] = 9] = "UniversalSortableDateTime";
  DateFormat[DateFormat["YearMonth"] = 10] = "YearMonth";
  DateFormat[DateFormat["Custom"] = 11] = "Custom";
  return DateFormat;
}({});
//# sourceMappingURL=DateFormat.js.map